import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../shared/Footer';
import Header from '../shared/Header';
import PageMeta from '../components/PageMeta';

const Main = () => {
    return (
        <main>
            <PageMeta />
            <Header/>
            <Outlet/>
            <Footer/>
        </main>
    );
};

export default Main;